var elementsForm,contLogin;
$(function() {
    $('.submitModalAccountInfo').click(function () {
        $('#modalAccountInfoForm').submit();
    });

    $('#modalAccountInfoForm').on('submit', function (e) {
        e.preventDefault();

        elementsForm = [
            "nameBabyModInfo",
            "birthDayBabyModInfo",
            "ageBabyModInfo",
            "feedingBabyModInfo",
            "allergicHistoryBabyModInfo",
            "diseasesBabyModInfo",
            "physicalConditionBabyModInfo",
            "nameMotherModInfo",
            "ccMotherModInfo",
            "professionMotherModInfo",
            "emailModInfo",
            "cellphoneModInfo",
            "countryModInfo",
            "stateModInfo",
            "cityModInfo",
            "addressModInfo",
            //"commentsModInfo",
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes completar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        let campo  = $("#emailModInfo").val();
        let emailRegex = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (emailRegex.test(campo.trim())) {
        } else {
            swal({
                text: "Debe digitar un correo electrónico valido",
                icon: imageURL,
                button: "OK",
            });
            document.getElementById("emailModInfo").focus();
            return false;
        }

        var data = $(this).serialize();

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });

        $.ajax({
            url: https + "UpdateInfo",
            method: "POST",
            data: data,
            success: function (data) {
                if ($.trim(data) == "1") {
                    location.reload();
                } else if ($.trim(data) == "2") {
                    swal({
                        title: "",
                        text: "¡Ese correo electronico ya existe, no se ha actualizado!",
                        icon: imageURL,
                    });
                    setTimeout(function () {
                        location.reload();
                    }, 2500)
                } else {
                    swal({
                        text: "Error, hubo problemas" + data,
                        icon: "warning",
                        button: "OK!",
                    });
                }
            }
        });

    });

    function validationForm(elementsForm, contLogin) {
        for (var i = 0; i < elementsForm.length; i++) {

            $('#' + elementsForm[i]).removeClass('error');

            if ($.trim($("#" + elementsForm[i]).val()) == "") {
                contLogin = 0;
                $('#' + elementsForm[i]).addClass('error');
            }

        }

        return contLogin;
    }

    $("#countryModInfo").change(function () {
        var country_id = $(this).val();
        getStates(country_id, 'stateModInfo');
    });

    $("#stateModInfo").change(function () {
        var state_id = $(this).val();
        getCities(state_id, 'cityModInfo');
    });

    $("#deparmentAddAddressInfo").change(function () {
        var state_id = $(this).val();
        getCities(state_id, 'cityAddAddressInfo');
    });

    $("#deparmentEditAddressInfo").change(function () {
        var state_id = $(this).val();
        getCities(state_id, 'cityEditAddressInfo');
    });


    function getStates(country_id, idElement) {
        $.ajax({
            url: https + "getStates",
            type: "POST",
            dataType: "json",
            data: {id: country_id, action: 'getStates'},
            success: function (datos) {
                $('#' + idElement + ' .opctions' + idElement).remove();
                $.each(datos, function (index, d) {
                    $('#' + idElement).append('<option class="opctions' + idElement + '" value="' + d.DisCodigo + '">' + d.DisNombre + '</option> ');
                });
            }
        });
    }

    function getCities(state_id, idElement) {
        $.ajax({
            url: https + "getCities",
            type: "POST",
            dataType: "json",
            data: {id: state_id, action: 'getCities'},
            success: function (datos) {
                $('#' + idElement + ' .opctions' + idElement).remove();
                $.each(datos, function (index, c) {
                    $('#' + idElement).append('<option class="opctions' + idElement + '" value="' + c.CiuCodigo + '">' + c.CiuNombre + '</option> ');
                });
            }
        });
    }

    $('.submitmModalAddAddressInfo').click(function () {
        $('#modalAddAddressInfoForm').submit();
    });

    $("#modalAddAddressInfoForm").on('submit', function (e) {
        e.preventDefault();
        elementsForm = [
            "nameAddAddressInfo",
            "descripcionAddAddressInfo",
            "addressAddAddressInfo",
            "townAddAddressInfo",
            "deparmentAddAddressInfo",
            "cityAddAddressInfo",
            "phoneAddAddressInfo",
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes completar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        var data = $(this).serialize();

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $("#modalAddAddressInfoForm")[0].reset();
        $.ajax({
            url: https + "newAddress",
            method: "POST",
            data: data,
            success: function (data) {

                if ($.trim(data) == "1") {
                    swal({
                        title: "",
                        text: "¡Agregada con exito!",
                        icon: imageURL,
                    });
                    setTimeout(function () {
                        location.reload();
                    }, 2000)
                } else {
                    swal({
                        text: "error, hubo problemas",
                        icon: imageURL,
                        button: "OK!",
                    });
                }

            }

        });

    });

    $('.editAddress').click(function () {
        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        var id = this.id;
        editAddress(id)
    });

    function editAddress(id) {
        $.ajax({
            async: true,
            type: "POST",
            dataType: "json",
            url: https + "editAddress",
            data: {id: id, action: 'editAddress'},
            success: function (datos) {
                $('#idEditAddressInfo').val(id);
                $('#nameEditAddressInfo').val(datos.name);
                $('#descripcionEditAddressInfo').val(datos.description);
                $('#addressEditAddressInfo').val(datos.address);
                $('#townEditAddressInfo').val(datos.town);
                $('#phoneEditAddressInfo').val(datos.phone);
                var idDeparment = datos.state;
                $('#deparmentEditAddressInfo').val(idDeparment);
                var idCity = datos.city;
                changeCityAddressEnvio(idDeparment, idCity);
            }
        });
    }

    function changeCityAddressEnvio(deparment, city) {
        $.ajax({
            async: true,
            type: "POST",
            dataType: "json",
            url: https + "getCities",
            data: {id: deparment, action: 'getCities'},
            success: function (datos) {
                $('#cityEditAddressInfo .opctionscityEditAddressInfo').remove();
                $.each(datos, function (index, c) {
                    $('#cityEditAddressInfo').append('<option class="opctionscityEditAddressInfo" value="' + c.CiuCodigo + '">' + c.CiuNombre + '</option> ');
                });
                $('#cityEditAddressInfo').val(city);
                swal.close();
                $('#modalEditAddressInfo').modal('open')
            }
        });
    }

    $('.submitmModalEditAddressInfo').click(function () {
        $('#modalEditAddressInfoForm').submit();
    });

    $("#modalEditAddressInfoForm").on('submit', function (e) {
        e.preventDefault();
        elementsForm = [
            "nameEditAddressInfo",
            "descripcionEditAddressInfo",
            "addressEditAddressInfo",
            "townEditAddressInfo",
            "deparmentEditAddressInfo",
            "cityEditAddressInfo",
            "phoneEditAddressInfo",
        ];

        contLogin = validationForm(elementsForm, contLogin = 1);

        if (contLogin == 0) {
            swal({
                text: "Debes completar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        var data = $(this).serialize();

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
        });
        $("#modalEditAddressInfoForm")[0].reset();
        $.ajax({
            url: https + "editAddressEnv",
            method: "POST",
            data: data,
            success: function (data) {

                if ($.trim(data) == "1") {
                    swal({
                        title: "",
                        text: "¡Editado con exito!",
                        icon: imageURL,
                    });
                    setTimeout(function () {
                        location.reload();
                    }, 2000)
                } else {
                    swal({
                        text: "error, hubo problemas",
                        icon: imageURL,
                        button: "OK!",
                    });
                }

            }

        });

    });

    $('.deleteAddress').click(function () {
        var id = this.id;
        deletedAddress(id);
    });

    function deletedAddress(id) {
        swal({
            title: "¿Seguro de hacer esto?",
            text: "",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    $.ajax({
                        url: https + "deletedAddress",
                        method: "POST",
                        data: {id: id, action: 'deletedAddress'},
                        success: function (data) {
                            if ($.trim(data) == "1") {
                                swal({
                                    title: "",
                                    text: "¡Eliminada con exito!",
                                    icon: imageURL,
                                });
                                setTimeout(function () {
                                    location.reload();
                                }, 2000)
                            } else {
                                swal({
                                    text: "error, hubo problemas",
                                    icon: imageURL,
                                    button: "OK!",
                                });
                            }

                        }

                    });
                } else {
                    return false;
                }
            });
    }
});